import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPCuspalSignificatorCuspalView } from './KPCuspalSignificatorCuspalView';
import { KPCuspalSignificatorPlanetView } from './KPCuspalSignificatorPlanetView';

export function KPCuspalSignificatorChart ({menuArray,userData}) {
  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[5]} className="m-0 p-0 ">
              <Row id="cuspalSignificatorsChart" className="m-0 p-0">
                  <Col xs={12} md={6} className="p-2 pt-0 m-0">
                    <KPCuspalSignificatorCuspalView userData={userData}/>
                  </Col>
                  <Col xs={12} md={6} className="p-2 pt-0 m-0">
                    <KPCuspalSignificatorPlanetView userData={userData}/>
                  </Col>
              </Row>
          </Collapse>
    }
  </>  
    );
}